//hoos
import { useState } from 'react';
import { useApi } from '../hooks/useApi';

//mui
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//api
import { PostBooking } from '../api/booking/PostBooking';
import card from '@material-tailwind/react/theme/components/card';


interface bookingProps {
    bookingRequest: {cardId: number | null; open: boolean, type: string}
    setBookingRequest: (bookingRequest: {cardId: number | null; open: boolean, type: string}) => void
}

const Booking = ({bookingRequest, setBookingRequest} : bookingProps) => {
    const { t } = useTranslation();

    const {
        loading: bookingLoading,
        error: bookingError,
        HandlerApi: bookingApi
    } = useApi(PostBooking, "POST");

    const handleClose = () => {
        setBookingRequest({cardId: null, open: false, type: ""});
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        formData.append("reservable_type", bookingRequest.type);
        formData.append("reservable_id", bookingRequest.cardId?.toString() || "");
        const formJson = Object.fromEntries((formData).entries());
        await bookingApi(formJson);
        setBookingRequest({cardId: null, open: false, type: ""});
    };

    return (
        <Dialog
        dir={i18n.language === "en" ? "ltr" : "rtl"}
        className={`!text-primaryColor ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"}`}
        open={bookingRequest.open} 
        onClose={handleClose} 
        fullWidth  maxWidth="md"
        >
        <div className='bg-[#EDEBDF] sm:px-6 max-sm:px-1'>
            <DialogTitle className={`max-sm:!py-0 max-sm:!pt-3 text-primaryColor ${i18n.language === "en" ? "!font-palab" : "!font-helvetica-arabic-bold"}`}>
            {t("book_now")}
            </DialogTitle>
            <DialogContent className='text-primaryColor'>
                <form onSubmit={handleSubmit}>
                    <div className="flex gap-3 max-sm:block">
                        <div className="w-1/2 mb-1 max-sm:w-full">
                            <p>{t("name")}</p>
                            <input 
                            type="text" 
                            name='client_name' 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            required
                            />
                        </div>
                        <div className="w-1/2 mb-1 max-sm:w-full">
                            <p>{t("phone")}</p>
                            <input 
                            type="number" 
                            name='client_phone' 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                            required
                            />
                        </div>
                        <div className="w-1/2 mb-1 max-sm:w-full">
                            <p>{t("email")}</p>
                            <input 
                            type="email" 
                            name='client_email' 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                            required
                            />
                        </div>
                    </div>
                    <div className='flex gap-3 max-sm:block'>
                        <div className="w-1/2 mb-1 max-sm:w-full">
                            <p >{t("start_date")}</p>
                            <input 
                            type="date"
                            name='check_in'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                            required
                            min={new Date().toISOString().split("T")[0]}
                            />
                        </div>
                        <div className="w-1/2 mb-1 max-sm:w-full">
                            <p>{t("end_date")}</p>
                            <input 
                            type="date" 
                            name='check_out'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                            required
                            min={new Date().toISOString().split("T")[0]}
                            />
                        </div>
                        <div className="w-1/2 mb-1 max-sm:w-full">
                            <p>{t("members_count")}</p>
                            <input 
                            type="number" 
                            name='members_count' 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                            required
                            />
                        </div>
                    </div>
                    <DialogActions className='mt-5'>
                            <button type="submit" className="m-auto w-1/2 max-sm:w-full p-1 rounded-lg bg-secondaryColor text-primaryColor">
                                {bookingLoading ? <CircularProgress className='!text-white'/> : t("request_booking")}
                            </button>
                    </DialogActions>
                </form>
            </DialogContent>
        </div>
        </Dialog>
    );
}

export default Booking
